import {reachUrls} from "../../layout/menu-items";

const SPACES = /\s+/g;
const DOTTED_SNIPPET_NAME = /^[\w.-]+$/;

export const snippetElementReference = (name: string): string => {
  const trimmed = name.trim();
  if (!trimmed) return "";
  const dotted = trimmed.replace(SPACES, ".");
  return DOTTED_SNIPPET_NAME.test(dotted) ? `{{snippets.${dotted}}}` : `{{snippets['${trimmed}']}}`;
};

export const snippetUrl = (id: number): string => `${reachUrls.snippets}/${id}`;
